import { render, staticRenderFns } from "./OptimisationSimulation.vue?vue&type=template&id=88b6a8ce&"
import script from "./OptimisationSimulation.vue?vue&type=script&lang=js&"
export * from "./OptimisationSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports